// extracted by mini-css-extract-plugin
module.exports = {"desktop":"image_desktop__PYCVF","mobile":"image_mobile__dF8JO","visibleDesktop":"image_visibleDesktop__7GBvf","imageLink":"image_imageLink__uLn5W"};